<template>
    <div>
        <van-popup
            v-model="localeValue"
            position="right"
            :style="popupStyle"
            :overlay="false"
        >
            <div class="main">
                <div class="header-content">
                    <div class="title">{{ i18n.t('nav') }}</div>
                    <div class="header-right">
                        <img src="../images/close.png" class="close" @click="localeValue = false" />
                    </div>
                </div>

                <div class="main__bottom">
                    <div v-for="item in moduleMenu" :key="item.moduleName" class="menu">
                        <div class="module-title" @click="item.collapsed = !item.collapsed">
                            <div class="name">{{ item.moduleName }}</div>
                            <img
                                src="../images/arrow.png"
                                class="arrow"
                                :class="{
                                    collapsed: item.collapsed,
                                }"
                            />
                        </div>

                        <div v-if="!item.collapsed" class="menu-list">
                            <div v-for="child in item.children" :key="child.name" class="menu-item" @click="goPage(child)">
                                {{ child.name }}
                            </div>
                        </div>
                    </div>

                    <div class="operation">
                        <Contact />
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getLangType } from '@/utils/tools'
import { i18n } from '../i18n'
import { isLogin, login } from '../utils'
import { debounce } from 'lodash'
import QrCodePopup from '@/components/QrCodePopup.vue'
import { getClientlist } from '@/apis/modules/uc'
import Contact from '@/components/contactCustomerService/contact.vue'

/** 与内容区 max-width 5.4rem（540px）断点一致 */
const NAV_MENU_WIDE_MIN_PX = 540

const moduleMenu = [
    {
        key: 'assets',
        needLogin: true,
        children: [
            {
                key: 'assetsHome',
                link: '/wealth/commonOutside.html#/',
            },
            {
                key: 'deposit',
                link: '/edda_app/?langType=' + getLangType(),
            },
            {
                key: 'withdraw',
                link: '/edda_app/transferOutFunds/?langType=' + getLangType(),
            },
            {
                key: 'currencyExchange',
                link: '/edda_app/currency/exchange?langType=' + getLangType(),
            },
            {
                key: 'orderRecords',
                link: '/wealth/fund.html#/order-list',
            },
        ],
    },
    {
        key: 'finance',
        children: [
            {
                key: 'financeHome',
                link: '/wealth/commonOutside.html#/wealth',
            },
            {
                key: 'cashbox',
                link: '/wealth/cashBox.html#/?immersive=1',
            },
            {
                key: 'publicFund',
                link: '/wealth/fund.html#/list',
            },
            {
                key: 'bill',
                link: '/wealth/fund.html#/invest-product/alter-investments',
            },
            {
                key: 'bond',
                link: '/wealth/fund.html#/bond',
            },
        ],
    },
]

export default {
    components: {
        Contact,
        QrCodePopup,
    },
    props: {
        value: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            i18n,
            isLogin,
            showContact: false,
            moduleMenu: moduleMenu
                .filter(el => !el.needLogin || isLogin)
                .map(el => ({
                    collapsed: true,
                    moduleName: i18n.t(el.key),
                    children: el.children
                        .filter(el => !el.needLogin || isLogin)
                        .map(child => ({
                            ...child,
                            name: i18n.t(child.key),
                        })),
                })),
            innerHeight: window.innerHeight,
            viewportMin540: typeof window !== 'undefined' && window.innerWidth >= NAV_MENU_WIDE_MIN_PX,
            showPopupStatus: false,
            showQTCode: false,
        }
    },
    computed: {
        ...mapState('user', ['userInfo']),
        popupStyle() {
            const style = {
                height: `${this.innerHeight}px`,
                width: '3.75rem',
            }
            if (this.viewportMin540) {
                style.left = 'calc(50% - 1.075rem)'
            }
            return style
        },
        localeValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    mounted() {
        this.initScroll()
        this.getQRCode()
    },
    methods: {
        goPage({ link, key }) {
            if (key === 'cashBox') {
                if (!isLogin) {
                    login()
                    return
                }
            }
            location.href = `${location.origin}${link}`
            this.localeValue = false
        },
        initScroll() {
            const onScroll = debounce(() => {
                this.innerHeight = window.innerHeight
                this.viewportMin540 = window.innerWidth >= NAV_MENU_WIDE_MIN_PX
            }, 200)
            onScroll()
            window.addEventListener('resize', onScroll)
            // 组件销毁时，移除事件监听
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('resize', onScroll)
            })
        },
        // 展示弹窗
        showPopup() {
            this.showPopupStatus = !this.showPopupStatus
        },
        async getQRCode() {
            try {
                const getUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
                const cltId = getUserInfo?.clientInfo?.accts?.[0]?.cltId || ''

                if (!getUserInfo || !Number(localStorage.getItem('uin'))) {
                    this.showQTCode = false
                    return
                }

                const params = {
                    uin: Number(localStorage.getItem('uin')),
                    cltId,
                }
                const { data } = await getClientlist(params)
                const result = data?.result || []
                const hasValidQrCode = result.some(item => item.qrCode)
                if (hasValidQrCode) {
                    this.showQTCode = true
                }
            } catch (e) {
                console.error('UserAdvisorList===>error:', e)
            }
        },
    },
}
</script>
<style scoped lang="less">
.header,
.module-title {
    font-weight: 600;
    background: white;
}

.header {
    justify-content: space-between;
    height: 44px;
    font-size: 18px;

    .close {
        width: 24px;
    }
}

.module-title {
    justify-content: space-between;
    height: 56px;
    font-size: 16px;

    .arrow {
        width: 24px;
        height: 24px;
        transition: 0.3s transform;

        &.collapsed {
            transform: rotate(180deg);
        }
    }
}

.header,
.module-title,
.menu-item {
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 12px;
}

.menu-list {
    font-size: 14px;
    background: #f8f8f8;

    .menu-item {
        height: 48px;
        margin-left: 12px;
        padding: 0;
        box-shadow: 0 -0.5px 0 0 #efefef inset;

        &:nth-last-child(1) {
            box-shadow: none;
        }
    }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;

    &::after {
        position: absolute;
        top: 14px;
        left: calc(50% - 1px);
        display: block;
        width: 1px;
        height: 20px;
        background-color: #efefef;
        content: '';
    }

    .item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 50%;

        > img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
        }
    }
}

.main {
    height: calc(100% - var(--nav-header-height));

    .main__bottom {
        height: 100%;
        margin-top: var(--nav-header-height);
        overflow: auto;
    }
}

.header-content {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 3.75rem;
    height: 44px;
    margin: 0 auto;
    padding: 0 12px;
    background: white;

    .title {
        overflow: hidden;
        font-weight: 600;
        font-size: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .close {
        width: 24px;
    }

    .header-right {
        flex-shrink: 0;
        margin-left: 32px;
    }
}
</style>
